import request from '../httpClient';
// tslint:disable
export const getListings = (params: any) => request.get('/listings', params);

export const getV3Listings = (params: any) =>
  request.get('/v3/listings', params);

export const updateStaahListingMapping = (
  listingId: number,
  staahListingId: string,
  staahRateId: string
) =>
  request.put('/v3/listings/staah_mappings', {
    listingId,
    staahListingId,
    staahRateId
  });

export const searchListings = (q: string, teamId: number) =>
  request.get(`/listings`, {name: q, team_id: teamId});

export const bulkAssignListingMembers = (body: any) =>
  request.put('/listings/members', body);

export const getListing = (listingId: number, format?: string) => {
  const params = format ? {_format: format} : {};
  return request.get(`/listings/${listingId}`, params);
};

export const getListingVariant = (
  listingId: number,
  listingVariantId: number
) => request.get(`/listings/${listingId}/variants/${listingVariantId}`);

export const assignMemberToListing = (listingId: number, userId: number) =>
  request.put(`/listings/${listingId}/assign/${userId}`);

export const removeMemberListing = (listingId: number, userId: number) =>
  request.delete(`/listings/${listingId}/assign/${userId}`);

export const createListing = (body: any) => request.post('/listings', body);



// WEBPACK FOOTER //
// ./src/services/api/listingApi.ts